import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import AppShell from "@/components/AppShell";
import HomePage from "@/pages/HomePage";
import UploadPage from "@/pages/UploadPage";
import AnalyzingPage from "@/pages/AnalyzingPage";
import ResultPage from "@/pages/ResultPage";
import TranslationPage from "@/pages/TranslationPage";
import ActionsPage from "@/pages/ActionsPage";
import ReplyPage from "@/pages/ReplyPage";
import LettersPage from "@/pages/LettersPage";
import ProfilePage from "@/pages/ProfilePage";
import AuthPage from "@/pages/AuthPage";
import PricingPage from "@/pages/PricingPage";
import ImpressumPage from "@/pages/ImpressumPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPages";
import { AppProvider } from "@/state/AppContext";

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/upload" element={<UploadPage />} />
            <Route path="/analyzing" element={<AnalyzingPage />} />
            <Route path="/result" element={<ResultPage />} />
            <Route path="/translation" element={<TranslationPage />} />
            <Route path="/actions" element={<ActionsPage />} />
            <Route path="/reply" element={<ReplyPage />} />
            <Route path="/letters" element={<LettersPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/agb" element={<TermsPage />} />
            <Route path="/datenschutz" element={<PrivacyPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}
